import React from 'react';
import '../styles/Partnerships.css';
import Navbar from './Navbar';
import Footer from './Footer';
import { FaRocket, FaCode, FaRobot, FaBrain, FaHandshake, FaMusic, FaVideo } from 'react-icons/fa';

const Partnerships = () => {
  return (
    <div className="partnerships-wrapper">
      <Navbar />
      <div className="partnerships-hero">
        <div className="partnerships-hero-content">
          <div className="partnerships-hero-badge">
            <FaHandshake className="partnerships-badge-icon" />
            <span>Our Partners</span>
          </div>
          <h1>Strategic Partnerships</h1>
          <p>Collaborating with industry leaders to bring you cutting-edge AI solutions</p>
        </div>
      </div>

      <div className="partnerships-grid">
        <div className="partnership-card tiktok-ai">
          <div className="partnership-header">
            <img 
              src="https://www.tiktokaieth.com/tai_logo.png" 
              alt="TikTok AI Logo" 
              className="partner-logo"
            />
            <h2>TikTok AI</h2>
          </div>
          <p className="partnership-description">
            Our strategic partnership with TikTok AI focuses on revolutionizing video content creation through AI technology. We provide the core AI infrastructure that powers their advanced video generation and editing capabilities.
          </p>
          <div className="partnership-features">
            <div className="feature">
              <FaVideo className="feature-icon" />
              <div className="feature-content">
                <h3>Video AI Technology</h3>
                <p>State-of-the-art AI models for video generation and processing</p>
              </div>
            </div>
            <div className="feature">
              <FaRobot className="feature-icon" />
              <div className="feature-content">
                <h3>Smart Video Processing</h3>
                <p>Intelligent video rendering and optimization systems</p>
              </div>
            </div>
          </div>
          <a 
            href="https://tiktokaieth.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="partner-link"
          >
            <span>Visit TikTok AI</span>
            <FaRocket className="link-icon" />
          </a>
        </div>

        <div className="partnership-card live-ai">
          <div className="partnership-header">
            <img 
              src="https://www.liveaieth.com/assets/liveAI_logo-DS1amYAK.png" 
              alt="Live AI Logo" 
              className="partner-logo"
            />
            <h2>Live AI</h2>
          </div>
          <p className="partnership-description">
            Our collaboration with Live AI is focused on pushing the boundaries of AI-powered music and audio creation. We provide the technical foundation for their innovative audio generation and processing capabilities.
          </p>
          <div className="partnership-features">
            <div className="feature">
              <FaMusic className="feature-icon" />
              <div className="feature-content">
                <h3>Music AI Generation</h3>
                <p>Advanced neural networks for music and sound creation</p>
              </div>
            </div>
            <div className="feature">
              <FaRobot className="feature-icon" />
              <div className="feature-content">
                <h3>Audio Processing</h3>
                <p>High-fidelity audio synthesis and enhancement systems</p>
              </div>
            </div>
          </div>
          <a 
            href="https://www.liveaieth.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="partner-link"
          >
            <span>Visit Live AI</span>
            <FaRocket className="link-icon" />
          </a>
        </div>

        <div className="partnership-card aria-ai">
          <div className="partnership-header">
            <img 
              src="https://www.ariaaieth.com/assets/aria-DkcN5gGx.png" 
              alt="Aria AI Logo" 
              className="partner-logo"
            />
            <h2>Aria AI</h2>
          </div>
          <p className="partnership-description">
            Aria AI is an innovative AI studio specializing in the generation of images, video, and 3D content. We collaborate to push creative boundaries.
          </p>
          <div className="partnership-features">
            <div className="feature">
              <FaVideo className="feature-icon" />
              <div className="feature-content">
                <h3>Multimedia AI Suite</h3>
                <p>Comprehensive AI tools for image, video, and 3D asset creation.</p>
              </div>
            </div>
            <div className="feature">
              <FaBrain className="feature-icon" />
              <div className="feature-content">
                <h3>Advanced Content Generation</h3>
                <p>Cutting-edge models for diverse and high-quality media output.</p>
              </div>
            </div>
          </div>
          <a 
            href="https://www.ariaaieth.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="partner-link"
          >
            <span>Visit Aria AI</span>
            <FaRocket className="link-icon" />
          </a>
        </div>
      </div>

      <div className="partnership-benefits">
        <h2>The Power of Collaboration</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <FaRobot className="benefit-icon" />
            <h3>Advanced AI Technology</h3>
            <p>Cutting-edge artificial intelligence solutions for video and audio content creation</p>
          </div>
          <div className="benefit-card">
            <FaCode className="benefit-icon" />
            <h3>Technical Excellence</h3>
            <p>Robust infrastructure and seamless blockchain integration for optimal performance</p>
          </div>
          <div className="benefit-card">
            <FaBrain className="benefit-icon" />
            <h3>Innovation Focus</h3>
            <p>Continuous development of groundbreaking AI features and capabilities</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Partnerships; 